import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'modalTitle'
	| 'editNameLabel'
	| 'cancelButtonLabel'
	| 'saveButtonLabel'
	| 'nameIsSameErrorMessage'
	| 'channelNotFoundError'
	| 'genericError';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		modalTitle: {
			id: 'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final',
			defaultMessage: 'Edit Conversation',
			description:
				'Title text displayed at the top of a modal dialog when editing a conversation name within the AI conversation interface. Shown as the modal dialog header title. The purpose is to immediately communicate to the user what action the dialog represents, which is editing the name of a conversation.',
		},
		editNameLabel: {
			id: 'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final',
			defaultMessage: 'Name',
			description:
				'Label text displayed above or next to a text input field for the conversation name in the edit conversation modal dialog within the AI conversation interface. Shown as a form field label. The purpose is to identify the name input field, which allows users to enter or edit the new name for the conversation.',
		},
		cancelButtonLabel: {
			id: 'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final',
			defaultMessage: 'Cancel',
			description:
				'Button label displayed on the cancel button in the edit conversation modal dialog within the AI conversation interface. Shown as the text on a button in the modal dialog. When clicked, it closes the dialog without saving any changes. The purpose is to provide users with a way to exit the edit dialog without applying changes.',
		},
		saveButtonLabel: {
			id: 'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final',
			defaultMessage: 'Save',
			description:
				'Button label displayed on the save button in the edit conversation modal dialog within the AI conversation interface. Shown as the text on a button in the modal dialog. When clicked, it saves the new conversation name and closes the dialog. The purpose is to provide a clear way for users to confirm and apply the name change.',
		},
		nameIsSameErrorMessage: {
			id: 'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final',
			defaultMessage: 'The name is the same as the current name.',
			description:
				'Validation error message displayed in the edit conversation modal dialog within the AI conversation interface when a user attempts to save a conversation name that is identical to the current name. Shown as an error message or validation text. The purpose is to inform the user that they must enter a different name to save changes.',
		},
		channelNotFoundError: {
			id: 'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final',
			defaultMessage: 'The channel you are trying to edit does not exist.',
			description:
				'Error message displayed in the edit conversation modal dialog within the AI conversation interface when attempting to edit a conversation that no longer exists. Shown as an error message in the modal. The purpose is to inform the user that the conversation they are trying to edit has been deleted or does not exist, possibly due to it being deleted by another user or session.',
		},
		genericError: {
			id: 'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final',
			defaultMessage: 'An error occurred while editing the conversation. Please try again.',
			description:
				'Error message displayed in the edit conversation modal dialog within the AI conversation interface when a generic error occurs while saving the conversation name. Shown as an error message in the modal. The purpose is to inform the user that the save operation encountered an unexpected error and prompt them to retry the action.',
		},
	});

export default message;
